import React, { useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import './ConsentDetails.scss';

const ConsentDetails = ({ onClose, carrier, status }) => {
  console.log(carrier,status, 'statusstatusstatusstatus')
  const ref = useRef(null);

  // Close the component if clicked outside
  useOnClickOutside(ref, onClose);

  const renderConsentSteps = () => {
    switch (carrier?.toLowerCase()) {
      case 'airtel':
        return 'Send SMS "Y" to 53848';
      case 'jio':
        return 'Give a missed call to 9982256700 or send "Y" to 51712025 or 5575701';
      case 'vodafone':
      case 'idea':
        return 'Please give a missed call to 7887810123 to complete the consent process.';
      default:
        return 'Tracking is not available!';
    }
  };

  return (
    <div ref={ref} className="consentDetails__container">
      <div className="consentDetails__content">
        <p>Consent Status: {status ? status : 'Pending'}</p>
        <p>Carrier: {carrier ? carrier : '-'}</p>
        <p>Consent Steps: {renderConsentSteps()}</p>
      </div>
    </div>
  );
};

export default ConsentDetails;
